// Recursos de imagen
export const IMG = {
  duoHero: "/assets/DUO.png",
  worldMap: "/assets/world_map.webp",
  duoApp: "/assets/duo_app.png",
  duoMap: "/assets/duo_map.png",
  duoFormat: "/assets/duo_format.png",
  duoEpisodes: "/assets/duo_episodes.png",
  duoBelievers: "/assets/duo_believers.png",
  duoVip: "/assets/duo_vip.png",
  duoLive: "/assets/duo_live.png",
  duoBiz: "/assets/duo_biz.png",
  season2Promo:
    "/assets/62cbf207055234c34b2a185dd3fa3fdefd3439edd8125b346cf7bb4bffb57594.jpeg",
  duoBelieversFans:
    "/assets/1e04eb44cfea6757252bd07bd05e5c6a5c1d6912923ac21cb0292ad4c9f7608e.jpeg",
  duoVipFans:
    "/assets/eb27bd3d6ed93ba30c994d44eddbf755697a4a6b78c7cbe8baa562f64ad43ac7.jpeg",
  duoSponsorMerch:
    "/assets/879eedf00c5f8a7597f8512c8ada9e2a280bd0e25275b917bf2406da894a8f72.jpeg",
  duoBrandProducts:
    "/assets/17f8910a448992f37cb74cae58f482829e7a178aa4904428e2c310b88e24d7b4.jpeg",
  bellaPortrait: "/assets/bella.jpg",
  antoPortrait:
    "/assets/f8f3b7c77a5a310f3e855bfa575ad83b8b806bfcb8c9c3e01667c0f8e941ca39.jpeg",
  airport:
    "/assets/airport.jpg",
};

// Insignias tipo sello de pasaporte — color asignado por destino
export const STAMP_COLORS = ["#FF8A80", "#A8E6CF", "#81D4FA", "#E8C547"];

export const EPISODES = [
  {
    n: "01",
    city: "Ciudad de México",
    country: "México",
    title: "Raíces urbanas",
    status: "Esta semana",
    statusType: "now",
    code: "MEX",
    color: "#FF8A80",
    blurb:
      "Empezamos en casa. La megalópolis que lo tiene todo: historia prehispánica, arquitectura colonial, gastronomía de clase mundial y una vibra urbana imposible de copiar. Anto y Bella se pierden en Coyoacán y se reencuentran en el Zócalo.",
    img: "/assets/8bed939a13be625161002a16f8d4f776fc91ecb648bf3ef8cf5d09cc5ddf2217.jpeg",
  },
  {
    n: "02",
    city: "Cancún / Riviera Maya",
    country: "México",
    title: "Agua y memoria",
    status: "Próximo",
    statusType: "next",
    code: "CUN",
    color: "#81D4FA",
    blurb: "El Caribe mexicano más allá de los resorts. Cenotes, ruinas mayas, arena blanca, el mar turquesa que ninguna foto hace justicia y una historia maya. El reto: nadar con tiburones ballena.",
    img: "/assets/cf9f9c6f3d622089d7c529955180be85ea9ec7a266b8ba68e25af41f69d18651.jpeg",
  },
  {
    n: "03",
    city: "Nueva York",
    country: "EE. UU.",
    title: "La ciudad que nunca duerme",
    status: "Próximo",
    statusType: "next",
    code: "NYC",
    color: "#A8E6CF",
    blurb: "Broadway, el Met, azoteas con vida, la Estatua de la Libertad y los mejores bagels del planeta. Bella sueña con actuar en un escenario de Manhattan. Anto quiere encontrar el mejor hot dog del mundo.",
    img: "/assets/3ea9b30322ba028fb4c6e37c51433482c26fc83550e9c09da34595dd7c106f08.jpeg",
  },
  {
    n: "04",
    city: "Tokio",
    country: "Japón",
    title: "Tecnología + tradición",
    status: "Próximo",
    statusType: "next",
    code: "TYO",
    color: "#FF8A80",
    blurb: "El lugar donde el futuro y el pasado conviven en la misma calle. Templos milenarios junto a tiendas de anime, robots que sirven ramen, calles de neón y trenes que llegan al segundo. El pasado y el futuro compartiendo la misma esquina.",
    img: "/assets/4df4d9a4e4bb977fff809865a212be42c0d936a0cb39773bc0d21dbfa6362276.jpeg",
  },
  {
    n: "05",
    city: "París",
    country: "Francia",
    title: "Sueños y arte",
    status: "Próximo",
    statusType: "next",
    code: "PAR",
    color: "#E8C547",
    blurb: "La ciudad de la luz, los croissants, el Louvre, museos, cafés y esa manera francesa de convertir todo, hasta un croissant, en arte. Para Bella, el paraíso de la moda y el ballet clásico. Para Anto, los museos de arte contemporáneo y las creperías de Montmartre.",
    img: "/assets/d4f780fb22786e5705d0ab4964d8a30bde19ee16d635ff51a6b3528195c4d0e6.jpeg",
  },
  {
    n: "06",
    city: "Río de Janeiro",
    country: "Brasil",
    title: "Ritmo y playa",
    status: "Próximo",
    statusType: "next",
    code: "RIO",
    color: "#81D4FA",
    blurb: "Ipanema, el Cristo Redentor, la samba, fut de playa, favelas de colores y el mar más alegre del planeta. El reto de este episodio: aprender a bailar samba en 24 horas. Spoiler: Anto lo logra. Bella lo intenta con dignidad.",
    img: "/assets/3401e3469a6938ed8e3e7853c2bacf8e9b7df01e10e51ed6c5a28b08fac49cc0.jpeg",
  },
  {
    n: "07",
    city: "Londres",
    country: "Reino Unido",
    title: "Historia y modernidad",
    status: "Próximo",
    statusType: "next",
    code: "LDN",
    color: "#A8E6CF",
    blurb: "Del Big Ben al Camden Market, de Buckingham a Shoreditch, mercados vintage y una lluvia que hace todo más cinematográfico.La ciudad que inventó la música moderna y nunca olvidó su historia de siglos.",
    img: "/assets/5d084ec17dc357b7adf8c33e9c74153db403e2ec2093b5b5b063341fe7b990a0.jpeg",
  },
  {
    n: "08",
    city: "Seúl",
    country: "Corea del Sur",
    title: "K-culture y futuro",
    status: "Próximo",
    statusType: "next",
    code: "SEL",
    color: "#FF8A80",
    blurb: "K-pop, skincare de 10 pasos, street food en Myeongdong, palacetes de la dinastía Joseon, K-pop, palacios y una escena creativa que va cinco años por delante. Anto encuentra su paraíso gamer. Bella descubre que el K-drama era real.",
    img: "/assets/e2497444550e6cbc5547ce10044d0be29f0f9f6f0d469f8da2832215305c1419.jpeg",
  },
  {
    n: "09",
    city: "Cusco / Machu Picchu",
    country: "Perú",
    title: "Misterio andino",
    status: "Próximo",
    statusType: "next",
    code: "CUZ",
    color: "#E8C547",
    blurb: "La ciudad en las nubes. El Imperio Inca, el Camino Inca y la ciudadela más fotografiada del mundo. A 3,400 metros de altitud, hasta respirar se siente diferente. Montañas sagradas, llamas curiosas y una ciudad de piedra que desafía al tiempo.",
    img: "/assets/6b17b888944fec2fdfe382d94c184bd8fab4b07e79d01db4d0200bc4575a0433.jpeg",
  },
  {
    n: "10",
    city: "Dubái",
    country: "EAU",
    title: "Lujo y desierto",
    status: "Próximo",
    statusType: "next",
    code: "DXB",
    color: "#81D4FA",
    blurb: "El Burj Khalifa, el desierto en camello y el souq de las especias. Un lugar donde lo imposible se construyó en menos de una generación. Rascacielos imposibles y dunas doradas al atardecer. Todo a la máxima escala. El reto: esquiar bajo el sol del desierto y comer oro.",
    img: "/assets/0288946447e3dd36b8158ae68712731899640ebae0ea68f03d667b6a967f7152.jpeg",
  },
  {
    n: "11",
    city: "Barcelona",
    country: "España",
    title: "Arte y playa mediterránea",
    status: "Próximo",
    statusType: "next",
    code: "BCN",
    color: "#A8E6CF",
    blurb: "Gaudí, la Barceloneta, el Barrio Gótico, tapas y el Mediterráneo y la mejor paella. La ciudad donde el arte vive en la arquitectura de cada esquina. La ciudad favorita de Anto, por razones obvias. Anto se va a vivir aquí, dice. Bella...Siempre lo dices.",
    img: "/assets/a1d6f4ab03343d818ebab52ed4eb71ade9e21315efaeb41d61fdfb545a2b3062.jpeg",
  },
  {
    n: "12",
    city: "Medellín (Parceros)",
    country: "Colombia",
    title: "Amistad y transformación",
    status: "Próximo",
    statusType: "next",
    code: "MDE",
    color: "#FF8A80",
    blurb: "La ciudad de la eterna primavera y el final de temporada 1. Un episodio sobre lo que el viaje dejó en ellas: nuevas amigas, nuevas perspectivas y la certeza de que el mundo es más grande y más bonito de lo que creían.",
    img: "/assets/7b8b1399f4a8e2ce07d573e14ed4127343aba196f0905bf2eca58cab271da840.jpeg",
  },
];

export const SEASON2_META = {
  title: "Una nueva ruta al terminar la #1",
  range: "Oaxaca a Cartagena",
  chapters: "12 capítulos",
  subtitle:
    "Doce nuevos destinos: de Oaxaca y El Cairo a Marrakech, Kioto, Ciudad del Cabo, Reikiavik, Bangkok y Cartagena. La ruta más ambiciosa del dúo.",
};

export const SEASON2 = [
  {
    n: "01",
    city: "Oaxaca",
    country: "México",
    code: "OAX",
    theme: "Colores",
    color: "#FF8A80",
    blurb: "Telares, alebrijes y cocina de humo.",
    img: "/assets/54b05181bdaaec76dcd301576bddd25a2dcb85942d653ac5e79be118f88a2357.jpeg",
  },
  {
    n: "02",
    city: "El Cairo",
    country: "Egipto",
    code: "CAI",
    theme: "Tiempo",
    color: "#E8C547",
    blurb: "Pirámides, río y una pregunta.",
    img: "/assets/ac300d0394157f7bb5b8beb5d283167ca33dedb9131cb3eb142be60285390220.jpeg",
  },
  {
    n: "03",
    city: "Lisboa",
    country: "Portugal",
    code: "LIS",
    theme: "Azulejos",
    color: "#81D4FA",
    blurb: "Tranvías, miradores y una ciudad junto al río.",
    img: "/assets/d00ab79c39f0f20d49e09168e92c74d1d57aea910b6979ac716ed772bb46ddfd.jpeg",
  },
  {
    n: "04",
    city: "Estambul",
    country: "Turquía",
    code: "IST",
    theme: "Cruces",
    color: "#A8E6CF",
    blurb: "Un bazar, dos orillas y muchas conversaciones.",
    img: "/assets/a789dbe55c611883344a3ae5d8ffba1dcb753351ddae99083df9d31a147c5751.jpeg",
  },
  {
    n: "05",
    city: "Buenos Aires",
    country: "Argentina",
    code: "BUE",
    theme: "Ritmo",
    color: "#FF8A80",
    blurb: "Barrios, dibujos y el pulso de una plaza.",
    img: "/assets/4c6e6a7aba4ddc4dbcb7f59808a0aca1bbf7a6a32308e0a62ef9c0cd481c9065.jpeg",
  },
  {
    n: "06",
    city: "Vancouver",
    country: "Canadá",
    code: "YVR",
    theme: "Horizontes",
    color: "#81D4FA",
    blurb: "Agua, montaña y una ciudad que mira lejos.",
    img: "/assets/8c65f635126b6d98fee2866504a6e2751d01eae273d11eb16f395f8715692132.jpeg",
  },
  {
    n: "07",
    city: "Marrakech",
    country: "Marruecos",
    code: "RAK",
    theme: "Especias",
    color: "#E8C547",
    blurb: "Zocos, lámparas y un laberinto de colores.",
    img: "/assets/.jpeg",
  },
  {
    n: "08",
    city: "Kioto",
    country: "Japón",
    code: "UKY",
    theme: "Templos",
    color: "#FF8A80",
    blurb: "Torii rojos, cerezos y silencio que enseña.",
    img: "/assets/.jpeg",
  },
  {
    n: "09",
    city: "Ciudad del Cabo",
    country: "Sudáfrica",
    code: "CPT",
    theme: "Océanos",
    color: "#81D4FA",
    blurb: "Una montaña plana, dos mares y casas de colores.",
    img: "/assets/.jpeg",
  },
  {
    n: "10",
    city: "Reikiavik",
    country: "Islandia",
    code: "REK",
    theme: "Auroras",
    color: "#A8E6CF",
    blurb: "Luces verdes en el cielo y volcanes dormidos.",
    img: "/assets/.jpeg",
  },
  {
    n: "11",
    city: "Bangkok",
    country: "Tailandia",
    code: "BKK",
    theme: "Mercados",
    color: "#FF8A80",
    blurb: "Mercados flotantes, templos dorados y sabores.",
    img: "/assets/.jpeg",
  },
  {
    n: "12",
    city: "Cartagena",
    country: "Colombia",
    code: "CTG",
    theme: "Caribe",
    color: "#E8C547",
    blurb: "Murallas, buganvilias y el pulso del Caribe.",
    img: "/assets/.jpeg",
  },
];

export const ACTS = [  {
    n: "01",
    title: "@Apertura-Llegada (Dopamina)",
    desc: "El primer contacto de una ciudad nueva. El aeropuerto, la ciudad desde el taxi, el hotel. Anto y Bella reaccionan en tiempo real: sorpresa, cansancio de vuelo y los primeros comentarios sin filtro sobre el nuevo lugar.",
    img: "/assets/7d7c75eb2b6ea26b2101bff85342137841cc6be3ee612077ca99c80b9b1fc756.jpeg",
    duration: "~8 min",
    bellaSays: "Llega impecable. Maleta coordinada. Ya investiga el restaurante en Tripadvisor.",
    antoSays: "Llega con cara de no haber dormido y lo documenta todo en vertical con cara de susto.",
  },
  {
    n: "02",
    title: "@Exploración (Adrenalina)",
    desc: "Recorren el destino siguiendo sus propios intereses. Bella va a museos, teatros y sitios históricos. Anto busca mercados, estudios de diseño y cafés con buena WiFi. Se encuentran al final para comparar sus versiones del lugar.",
    img: "/assets/ec0473834882a3004d2b7f0ba5208c700cc03edd122817dc939d791c9962fd61.jpeg",
    duration: "~12 min",
    bellaSays: "Va con ropa de época al museo. Habla con el curador.",
    antoSays: "Encuentra un mural callejero y lo convierte en contenido.",
  },
  {
    n: "03",
    title: "@Unboxing — Qué empacaron (Cortisol)",
    desc: "El segmento más viral. Cada episodio revelan qué trajeron en la maleta para ese destino específico. Qué llevó cada una y por qué dice tanto de quiénes son.Los contrastes son siempre brutales y divertidos.",
    img: "/assets/daded7813afb780e2f0ca058cdf0b408fd73fecf15b8befdc24a1dbe839d5c9c.jpeg",
    duration: "~6 min",
    bellaSays: "Outfits por día, separados en bolsitas. Adaptadores organizados por región.",
    antoSays: "Una bolsa grande donde entró todo. Incluye una consola y tres libros de diseño.",
  },
  {
    n: "04",
    title: "@Reto local (Oxitocina)",
    desc: "El corazón del episodio. Cada destino propone un reto representativo de su cultura: aprender samba en Río, nadar con tiburones ballena en Cancún, cocinar ramen en Tokio. Las reglas: 24 horas, sin instrucciones en español.",
    img: "/assets/0e9cf5009458572f32866b971cafa39db68341f362100d92801f7aded181b84c.jpeg",
    duration: "~10 min",
    bellaSays: "Lo enfrenta con estrategia y técnica. A veces gana.",
    antoSays: "Lo enfrenta con improvisación y risa. Siempre genera el momento viral.",
  },
  {
    n: "05",
    title: "@Momento real (Serotonina)",
    desc: "El segmento más íntimo. Una conversación grabada en la habitación del hotel, de noche, donde hablan de cómo las afectó el destino. Sin cámara formal, sin maquillaje. Solo ellas dos siendo honestas. Una conversación honesta.",
    img: "/assets/970cbab0065309eb849a2901dbc71d0486aa43d9efff5f2c16bb6ea5a7042402.jpeg",
    duration: "~5 min",
    bellaSays: "Reflexiva. Conecta lo que vio con sus sueños de actriz.",
    antoSays: "Honesta. A veces dice cosas que sorprenden a Bella. Siempre tiene razón.",
  },
  {
    n: "06",
    title: "@Cierre — Lo que nos llevamos (Intriga)",
    desc: "Regreso al aeropuerto. Cada una confiesa la cosa más importante que se lleva del destino: puede ser una receta, una frase, un recuerdo o una reflexión. El ritual que cierra cada episodio y Antes de despegar, una reflexión.",
    img: "/assets/e72672cc268f96698b16ebd8207c6676f91eb30c04df0bec664351e6b886629f.jpeg",
    duration: "~4 min",
    bellaSays: "Una lección elegante. Una promesa de volver.",
    antoSays: "Una cosa concreta que compró o aprendió. Y generalmente tiene cara.",
  },
];

export const SPONSOR_TIERS = [
  {
    name: "Naming Sponsor (Principal)",
    price: "$1,699,000",
    unit: "por episodio",
    highlight: true,
    type: "Naming Sponsor · dueño del episodio",
    acts: "6 de 6 actos",
    idealFor: "Marca que quiere ownership total del episodio",
    features: [
      "★Naming del episodio — presentado por Marca del patrocinador.",
      "★Exclusividad de categoría en todo el show",
      "★Integración orgánica en los 6 actos HCC-6™.",
      "★Presencia en plataformas digitales + Wifi + Venue.",
      "★6 menciones dinámicas por episodio.",
      "★Logotipo permanente en TV + streaming.",
      "★Co-branding completo en App móvil.",
      "★E-commerce activo — CTR 4–7% garantizado.",
      "★Show en vivo mensual — naming del evento.",
      "★Merchandising + impresos del programa.",
      "★Soporte de movilidad / proveedor oficial.",
      "★Reporte mensual completo de ROI.",
    ],
  },
  {
    name: "Sponsor Co-Branding",
    price: "$1,299,000",
    unit: "por episodio",
    highlight: false,
    type: "Sponsor · co-branding",
    acts: "6 de 6 actos",
    idealFor: "Alta frecuencia y visibilidad sin naming",
    features: [
      "Sub-presencia en los 6 actos del episodio *sin naming principal.",
      "Co-branding visual en TV, App, streaming y plataformas digitales.",
      "Presencia en show en vivo mensual como co-patrocinador.",
      "Merchandising + impresos del programa con tu logo.",
      "App móvil: sección de co-branding en mapas y pasaporte digital.",
      "E-commerce activo con cupón de la marca en App.",
      "Presencia en Wifi + Venue del show en vivo.",
      "Reporte mensual de rendimiento.",
    ],
  },
];

export const BRAND_TIERS = [
  {
    name: "Integración Total",
    price: "$1,499,000",
    unit: "por episodio",
    highlight: true,
    type: "Marca · product placement",
    acts: "6 de 6 actos",
    idealFor: "Marca que quiere todos los actos sin ser sponsor",
    features: [
      "★Presencia orgánica en los 6 actos del episodio.",
      "★Activación en App con información del producto en cada acto.",
      "★4 momentos LIVE con tu marca.",
      "★Cupón de descuento directo a tu e-commerce.",
      "★Contenido generado (fotos + clips) para redes sociales.",
      "★Reporte mensual de alcance, CTR y conversión.",
      "★Material reutilizable para tus propias campañas.",  
      "★Los 6 actos, App/Gaming y material reutilizable.",
      "★Plataforma incluida.",
      "*Sin naming, live ni merch del programa.",
    ],
  },
  {
    name: "Integración Premium",
    price: "$699,000",
    unit: "por episodio",
    highlight: false,
    type: "Marca · product placement",
    acts: "2 de 6 actos",
    idealFor: "Marca que busca Unboxing y Reto Local",
    features: [
      "*Selecciona 2 de los 6 actos según tu categoría.",
      "*Activación en App en los actos seleccionados.",
      "*1 momento LIVE vinculado a tu integración.",
      "*Cupón directo a e-commerce.",
      "*Material reutilizable para tus campañas.",
      "*Reporte de rendimiento.",
      "*App y plataforma incluidos.",
    ],
  },
  {
    name: "Integración Platino",
    price: "$449,000",
    unit: "por episodio",
    highlight: false,
    type: "Marca · product placement",
    acts: "1 de 6 actos",
    idealFor: "Marca que quiere un acto de alto impacto",
    features: [
    "Integración profunda en el acto de mayor relevancia para tu marca.",
    "*Activación en App en el acto seleccionado.",
    "Cupón directo a e-commerce.",
    "Material fotográfico del acto para tus redes.",
    "Reporte de rendimiento del acto.",
    "1 acto a elección. momento emocional de mayor impacto disponible.",
    ],
  },
  {
    name: "Integración Gold",
    price: "$299,000",
    unit: "por episodio",
    highlight: false,
    type: "Marca · product placement",
    acts: "1 de 6 actos",
    idealFor: "Prueba, lanzamiento o activación puntual",
    features: [
    "*Disponibilidad del acto sujeta a confirmación.",
    "Integración en 1 acto seleccionado.",
    "Aparición del producto en App (información básica).",
    "Acceso a audiencia de 350K–600K espectadores.",
    "Material para reposteo en redes de la marca.",
    ],
  },
];

export const VIP_PERKS = [
  "Episodios sin cortes y en estreno anticipado",
  "Detrás de cámaras exclusivo cada semana",
  "Bloopers y momentos que no salieron en TV",
  "Sorteos de merch firmado por Anto & Bella",
  "Chat de la comunidad VIP",
  "Tu nombre en los créditos digitales",
  "Video-llamada mensual con Anto & Bella",
  "Guías de viaje descargables de cada destino",
  "Descuentos exclusivos en la tienda de merch",
];

export const SCHEDULE = {
  main: "Sábados 20:00",
  region: "TV abierta · Sintoniza la señal abierta en la zona Occidente de México. Sin cable, sin costo, sin excusas.",
  replay: "Retransmisión ¿Te lo perdiste? El domingo repetimos el episodio para que no quede nadie fuera. Domingo 11:00",
};

// Televisoras (imágenes fake, reemplazables) que "transmiten" el programa en TV abierta
export const TV_NETWORKS = [
  { n: "Televisora 1", name: "Canal Uno", img: "/assets/tv1.jpeg" },
  { n: "Televisora 2", name: "Red Dos", img: "/assets/tv2.jpeg" },
  { n: "Televisora 3", name: "Tele Tres", img: "/assets/tv3.jpeg" },
  { n: "Televisora 4", name: "Visión 4", img: "/assets/tv4.jpeg" },
  { n: "Televisora 5", name: "Onda 5", img: "/assets/tv5.jpeg" },
  { n: "Televisora 6", name: "Seis TV", img: "/assets/tv6.jpeg" },
  { n: "Televisora 7", name: "Canal 7", img: "/assets/tv7.jpeg" },
];

// Grupo detrás del proyecto
export const GRUPO = {
  logo: "/assets/grupo-hiperconvercloud.png",
  url: "https://www.group-hiperconvercloud.org/",
  name: "Grupo HiperconverCloud",
};

// Actos detallados para la CAPA MARCA (cómo participa una marca en cada acto)
export const BRAND_ACTS = [
  { n: "01", icon: "Plane", title: "Apertura · Llegada", color: "#FF8A80", dark: false,
    img: "/assets/act_int_1.jpeg",
    desc: "Asocia tu marca con el momento de descubrimiento: la primera impresión del destino. Ideal para aerolíneas, equipaje, apps de viaje y turismo. Tu logo da la bienvenida al episodio." },
  { n: "02", icon: "Compass", title: "Exploración", color: "#A8E6CF", dark: false,
    img: "/assets/act_int_2.jpeg",
    desc: "Tu marca acompaña la aventura de conocer el destino con los ojos del dúo. Perfecto para gadgets, calzado, bebidas y wearables que viven el recorrido con ellas." },
  { n: "03", icon: "Package", title: "Unboxing / Empaque", color: "#81D4FA", dark: false,
    img: "/assets/act_int_3.jpeg",
    desc: "El segmento más viral. Perfecto para marcas de lifestyle, moda, tecnología y accesorios. Tu producto se abre en cámara con una reacción genuina y compartible." },
  { n: "04", icon: "Trophy", title: "Reto Local", color: "#E8C547", dark: false,
    img: "/assets/act_int_4.jpeg",
    desc: "Asocia tu marca con la aventura y el desafío: el acto de mayor engagement. Ideal para deportes, energía y outdoor que impulsan la acción." },
  { n: "05", icon: "MessageCircle", title: "Momento Real", color: "#EEF5F2", dark: false,
    img: "/assets/act_int_5.jpeg",
    desc: "El acto más auténtico. Para marcas que buscan conexión emocional genuina: bienestar, alimentos, hogar y causas con propósito." },
  { n: "06", icon: "Globe", title: "Cierre · Reflexión", color: "#2D3436", dark: true,
    img: "/assets/act_int_6.jpeg",
    desc: "Tu marca cierra el episodio, asociada al cierre emocional y al legado del viaje. Presencia premium en créditos y en la postal final." },
];

// Actos detallados para la CAPA PATROCINADOR (cómo participa el patrocinio titular en cada acto)
export const SPONSOR_ACTS = [
  { n: "01", icon: "Plane", title: "Apertura · Presenta", color: "#FF8A80", dark: false,
    img: "/assets/act_int_1.jpeg",
    desc: "Naming de entrada: «X presenta Anto&Bella por el Mundo». Tu marca abre el episodio en el bumper y da la bienvenida al destino. Máxima recordación." },
  { n: "02", icon: "Compass", title: "Exploración · Presencia", color: "#A8E6CF", dark: false,
    img: "/assets/act_int_2.jpeg",
    desc: "Presencia de marca durante el recorrido: cortinillas, lower-thirds y menciones naturales del dúo mientras descubren el destino." },
  { n: "03", icon: "Package", title: "Unboxing · Co-branding", color: "#81D4FA", dark: false,
    img: "/assets/act_int_3.jpeg",
    desc: "Co-branding en el segmento más viral: tu logo junto al del programa en el momento de mayor alcance en redes." },
  { n: "04", icon: "Trophy", title: "Reto Local · Activación", color: "#E8C547", dark: false,
    img: "/assets/act_int_4.jpeg",
    desc: "Activación de patrocinio: tu marca impulsa el reto del destino. Integración dinámica en el acto de mayor engagement." },
  { n: "05", icon: "MessageCircle", title: "Momento Real · Propósito", color: "#EEF5F2", dark: false,
    img: "/assets/act_int_5.jpeg",
    desc: "Asociación con el mensaje del episodio: propósito y responsabilidad social. Tu marca se vincula a la conversación honesta del dúo." },
  { n: "06", icon: "Globe", title: "Cierre · Legado", color: "#2D3436", dark: true,
    img: "/assets/act_int_6.jpeg",
    desc: "Bumper de salida y créditos: tu marca cierra con el legado del viaje. Cierre emocional premium que se queda con la audiencia." },
];

// ROI ESTIMADO por episodio — cifras PROYECTADAS (no garantizadas), base: 7 señales de TV
// abierta zona Occidente de México + las 10 redes sociales del programa.
export const ROI_DISCLAIMER =
  "Cifras estimadas y proyectadas con fines ilustrativos. No constituyen una garantía de resultados; el desempeño real varía por destino, acto contratado y temporada.";

// 6 ejemplos de ROI alcanzable para MARCAS (integración por acto)
export const BRAND_ROI = [
  { icon: "Tv", label: "Alcance +7 señales", value: "11.5M", unit: "televidentes / episodio",
    desc: "Cobertura potencial en las 7 señales de TV abierta de la zona Occidente." },
  { icon: "APP", label: "Alcance APP Proyectado", value: "600K – 900K", unit: "personas / episodio",
    desc: "Suma de TV abierta (7 señales) más las 20 redes del programa por episodio." },
  { icon: "Eye", label: "Impresiones digitales", value: "~250,000", unit: "por episodio",
    desc: "Vistas estimadas en las 20 redes sociales del programa entre estreno y repetición." },
  { icon: "MessageCircle", label: "Menciones del dúo", value: "1 – 6", unit: "según actos contratados",
    desc: "Menciones naturales y editoriales de Anto & Bella dentro del contenido." },
  { icon: "Heart", label: "Engagement proyectado", value: "4% – 7%", unit: "en piezas co-branded",
    desc: "Interacción estimada (likes, comentarios, compartidos) sobre el contenido con tu marca." },
  { icon: "Clapperboard", label: "Piezas de contenido", value: "1 – 3", unit: "reels reutilizables",
    desc: "Clips co-branded que puedes reutilizar en tus propios canales sin costo extra." },
  { icon: "TrendingUp", label: "CPM proyectado", value: "desde ~$99", unit: "MXN por mil impresiones",
    desc: "Costo por mil competitivo frente a un spot tradicional de TV." },
];

// 6 ejemplos de ROI alcanzable para PATROCINADORES (naming / titular)
export const SPONSOR_ROI = [
  { icon: "Tv", label: "Alcance +7 señales", value: "11.5M", unit: "personas / episodio",
    desc: "Suma de TV abierta (7 señales) más las 20 redes del programa por episodio." },
  { icon: "APP", label: "Alcance APP Proyectado", value: "600K – 900K", unit: "personas / episodio",
    desc: "Suma de TV abierta (7 señales) más las 20 redes del programa por episodio." },
  { icon: "Sparkles", label: "CTR en App Proyectado", value: "4–7%", unit: "hacia e-commerce",
    desc: "Suma de TV abierta (7 señales) más las 20 redes del programa por episodio." },	
  { icon: "Sparkles", label: "CPM Proyectado", value: "$99 MXN", unit: "blended TV + Digital",
    desc: "Suma de TV abierta (7 señales) más las 20 redes del programa por episodio." },	
  { icon: "Sparkles", label: "Recordación de marca", value: "+30% – 45%", unit: "vs. co-branding simple",
    desc: "Lift de recordación proyectado por el naming en apertura y cierre del episodio." },
  { icon: "MessageCircle", label: "Menciones garantizadas", value: "4+", unit: "apertura, cierre y 2 actos",
    desc: "Presencia asegurada en los momentos de mayor atención del episodio." },
  { icon: "Eye", label: "Impresiones digitales", value: "400K – 700K", unit: "por episodio",
    desc: "Vistas proyectadas en las 20 redes sociales entre estreno y repetición." },
  { icon: "Clapperboard", label: "Contenido nativo", value: "3+", unit: "piezas + reporte",
    desc: "Reels y cápsulas con tu marca más un reporte de audiencia certificado." },
  { icon: "ShieldCheck", label: "Share of voice", value: "100%", unit: "del naming del episodio",
    desc: "Exclusividad de categoría: eres la única marca titular del episodio." },
];
